<div class="session-expired-container">
    <div class="session-expired-content">
        <div class="session-expired-icon">
            <img class="timer-logo" alt="session expired" src="assets/img/timer.png">
        </div>
        <h1 class="session-expired-title">Session Expired</h1>
        <p class="session-expired-text">
            Your session has ended due to inactivity. This is a security measure to protect your information.
        </p>
        <p class="session-expired-subtext">
            Please log in again to resume your work.
        </p>
        <div class="session-expired-btn">
            <p-button
                label="Login"
                (onClick)="goToHome()"
                styleClass="p-button-primary" />
        </div>
    </div>
</div>
